import RunningLineListPage from '@/pages/running-line/ListPage'
import CreateUpdateRunningLinePage from '@/pages/running-line/CreateUpdatePage'

export default [
  {
    path: '/running-line/list',
    name: 'RunningLinesList',
    component: RunningLineListPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/running-line/create',
    name: 'CreateRunningLine',
    component: CreateUpdateRunningLinePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/running-line/update/:id',
    name: 'UpdateRunningLine',
    component: CreateUpdateRunningLinePage,
    meta: {
      requiresAuth: true,
    },
  },
]



